import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { ICGILevel } from 'modules/promptuary/interfaces/cgi.interface';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CGIService {
	serviceUrl = environment.servicesUrl;
	baselineLevels = [];

	constructor(public httpClient: HttpClient) {}

	public getBaselineLevels(): Observable<ICGILevel[]> {
		if (this.baselineLevels.length > 0) {
			return of(this.baselineLevels);
		}
		return this.httpClient
			.get<ICGILevel[]>(`${this.serviceUrl}/promptuary/v1/cgi/levels`)
			.pipe(
				tap((levels) => {
					this.baselineLevels = levels;
					return levels;
				})
			);
	}
}
